import { render, staticRenderFns } from "./expert-list.vue?vue&type=template&id=18c1a048"
import script from "./expert-list.vue?vue&type=script&lang=js"
export * from "./expert-list.vue?vue&type=script&lang=js"
import style0 from "./expert-list.vue?vue&type=style&index=0&id=18c1a048&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports